<template>
  <div class="container-fluid justify-content-center mt-5 webshop-payment-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 mb-3 payment-page-in-mobile">
        <h3 class="center-in-mobile" v-show="currentStep == 1">
          {{ $t(LangConstants.your_order_heading) }}
        </h3>
        <div class="row">
          <div class="col-md-12" v-show="currentStep == 1">
            <div class="row">
              <div class="col-md-10">
                  <webshop-product-item :event="currentEvent" :title="product.name" :imgUrl="product.images ? product.images[0] : ''" :subPeriod="this.paymentRecurringPeriod" :total="this.totalAmount" :description="product.description" :unitPrice="(this.unitPrice = !0 ? this.unitPrice : '')" :quantity="this.quantity"> </webshop-product-item>
              </div>
              <div class="col-md-2">
                <my-button fa="bars" :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit" @onClick="incrementStep(true)"></my-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mt-5">
               </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-show="currentStep == 2">
            <b-tabs v-model="tabIndex" content-class="col-md-12" class="custom-tab-control row d-flex justify-content-center align-items-center mt-2" align="center">
              <div id="company-payment-create-account" class="row form-base mt-1">
                <b-tab active :title="$t(LangConstants.create_account_title)" class="col-md-12">
                  <h3 class="mb-3">
                    {{ $t(LangConstants.create_account_title) }}
                  </h3>

                  <div class="col-12 form1">
                    <b-form ref="frmOrderCompanyCreate" @submit.stop.prevent="proceedBtnHandler">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="first-name" name="first-name" :label="$t(LangConstants.first_name_input_label)" placeholder="Andrew" inlinerows="false" :mandatory="true" classes="bg-gray" ref="firstName" v-model="stateStep2.firstName" :error="$v.stateStep2.$dirty && $v.stateStep2.firstName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="last-name" name="last-name" :label="$t(LangConstants.last_name_input_label)" placeholder="Hargempton" :mandatory="true" inlinerows="false" classes="bg-gray" ref="lastName" v-model="stateStep2.lastName" :error="$v.stateStep2.$dirty && $v.stateStep2.lastName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="email" name="email" :label="$t(LangConstants.your_email_input_label)" placeholder="someemail@example.com" inlinerows="false" :mandatory="true" classes="bg-gray" ref="registerEmail" type="email" v-model="stateStep2.registerEmail" :error="$v.stateStep2.$dirty && $v.stateStep2.registerEmail.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="password" name="password" :label="$t(LangConstants.choose_password_input_label)" placeholder="" inlinerows="false" :mandatory="true" classes="bg-gray" ref="registerPassword" type="password" v-model="stateStep2.registerPassword" :error="$v.stateStep2.$dirty && $v.stateStep2.registerPassword.$invalid ? ($v.stateStep2.registerPassword.$model != null ? $t(LangConstants.general_password_validation_message) : $t(LangConstants.invalid_input_error_message)) : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="phone" name="phone" :label="$t(LangConstants.phone_input_label)" placeholder="+13443543534534" inlinerows="false" :mandatory="true" classes="bg-gray" ref="phone" type="tel" v-model="stateStep2.phone" :error="$v.stateStep2.$dirty && $v.stateStep2.phone.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="org-name" name="org-name" :label="$t(LangConstants.organization_name_label)" placeholder="The Boooring testing Company" inlinerows="false" :mandatory="true" classes="bg-gray" ref="organizationName" v-model="stateStep2.organizationName" :error="$v.stateStep2.$dirty && $v.stateStep2.organizationName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="org-number" name="org-number" :label="$t(LangConstants.organization_number_label)" placeholder="0221212112" inlinerows="false" :mandatory="true" classes="bg-gray" ref="organizationNumber" v-model="stateStep2.organizationNumber" :error="$v.stateStep2.$dirty && $v.stateStep2.organizationNumber.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-4">
                            <my-checkbox id="marketingAackknowledgement" name="marketingAackknowledgement" inlinerows="false" :defaultText="$t(LangConstants.marketing_consent_text)" :secondaryText="marketingConsentHelperText" checkedValue="1" uncheckedValue="0" v-model="stateStep2.sendmarketingemails"> </my-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-4">
                            <my-button fa="bars" :label="stateStep3.isActivated ? $t(LangConstants.continue_button_label) : $t(LangConstants.contintue_with_payment_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                          </div>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </b-tab>

                <b-tab :title="$t(LangConstants.sign_in_tab_title)" class="col-md-12">
                  <b-form ref="frmOrderCompanyCreate" @submit.stop.prevent="proceedBtnHandler">
                    <h3 class="mb-3">
                      {{ $t(LangConstants.sign_in_tab_title) }}
                    </h3>
                    <div class="col-md-12 form1">
                      <div class="row d-flex justify-content-center">
                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="email" name="email" :mandatory="true" :label="$t(LangConstants.your_email_input_label)" placeholder="someemail@example.com" inlinerows="false" classes="bg-gray" ref="loginEmail" type="email" v-model="stateSignIn.loginEmail" :error="$v.stateSignIn.$dirty && $v.stateSignIn.loginEmail.$invalid ? Constants.invalid_input_error_message : ''"></my-input>
                          </div>
                        </div>
                      </div>

                      <div class="row d-flex justify-content-center">
                        <div class="col-md-6">
                          <div class="mb-4">
                            <my-input id="password" name="password" :mandatory="true" :label="$t(LangConstants.password_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="password" type="password" v-model="stateSignIn.password" :error="$v.stateSignIn.$dirty && $v.stateSignIn.password.$invalid ? ($v.stateSignIn.password.$model != null ? $t(LangConstants.general_password_validation_message) : $t(LangConstants.invalid_input_error_message)) : ''"></my-input>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-4">
                            <my-button fa="bars" :label="stateStep3.isActivated ? $t(LangConstants.continue_button_label) : $t(LangConstants.contintue_with_payment_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-form>
                </b-tab>
              </div>
            </b-tabs>
          </div>

          <div class="col-md-12" v-show="currentStep == 3">
            <div id="company-payment-select-payment-method" class="d-flex justify-content-center form-base row">
              <b-form class="col-md-12" ref="frmOrderCompanypaymentMethod" @submit.stop.prevent="proceedBtnHandler">
                <!-- <h3 class="mb-3"> Participant Details </h3> -->

                <div class="" v-if="quantity > 1">
                  <h4 class="mb-3">{{ $t(LangConstants.group_details_heading) }}</h4>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-4">
                        <my-input id="group-name" name="group-name" :label="$t(LangConstants.group_name_label)" placeholder="Andrew" inlinerows="false" classes="bg-gray" ref="groupName" v-model="stateStep3.groupName" :defaultText="stateStep3.groupName" :error="$v.stateStep3.$dirty && $v.stateStep3.groupName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-12">
                      <hr />
                    </div>
                  </div>
                </div>

                <div class="mb-3" v-for="(participant, index) in stateStep3.participants" :key="index">
                  <h5 v-if="stateStep3.participants.length > 1" class="mb-3 b">{{ $t(LangConstants.participant_title) + " " + (index + 1) }}</h5>
                  <h5 v-if="stateStep3.participants.length == 1" class="mb-3 b">{{ $t(LangConstants.participants_details_heading) }}</h5>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <div class="mb-4">
                        <my-input :id="'first-name-' + index" :mandatory="true" :name="'first-name-' + index" :label="$t(LangConstants.first_name_input_label)" placeholder="Erik" inlinerows="false" classes="bg-gray" ref="pFirstName" v-model="participant.firstName" :error="$v.stateStep3.$dirty && $v.stateStep3.participants.$each[index].firstName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-4">
                        <my-input :id="'last-name-' + index" :mandatory="true" :name="'last-name-' + index" :label="$t(LangConstants.last_name_input_label)" placeholder="Svensson" inlinerows="false" classes="bg-gray" ref="pLastName" v-model="participant.lastName" :error="$v.stateStep3.$dirty && $v.stateStep3.participants.$each[index].lastName.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-4">
                        <my-input :id="'email-' + index" :mandatory="true" :name="'email-' + index" :label="$t(LangConstants.email_input_label)" placeholder="erik.svensson@example.se" inlinerows="false" classes="bg-gray" ref="pEmail" type="email" v-model="participant.email" :error="$v.stateStep3.$dirty && $v.stateStep3.participants.$each[index].email.$invalid && participant.duplicatesVerified ? $t(LangConstants.invalid_input_error_message) : !participant.duplicatesVerified ? $t(LangConstants.duplicate_email) : ''"></my-input>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-4">
                        <my-input :id="'phone-' + index" :mandatory="true" :name="'phone-' + index" :label="$t(LangConstants.phone_input_label)" placeholder="+46 70 123 45 67" inlinerows="false" classes="bg-gray" ref="pPhone" type="tel" v-model="participant.phone" :error="$v.stateStep3.$dirty && $v.stateStep3.participants.$each[index].phone.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                      </div>
                    </div>

                    <!-- <div class="col-md-12" v-if="participant.signupField && participant.signupField.name != null">
                      <div class="mb-4">
                        <my-input :id="'signup-form-field-' + index" name="'signup-form-field-'+index" :label="participant.signupField.name" placeholder="" inlinerows="false" classes="bg-gray" ref="pSignupFormField" v-model="participant.signupField.value"></my-input>
                      </div>
                    </div> -->
                    <div class="" v-if="participant.signupFields">
                      <div class="col-md-12" v-for="(signupField, index) in participant.signupFields" :key="index">
                        <div class="mb-4" v-if="signupField.type == 1">
                          <my-input :id="'signup-form-field-' + index" name="'signup-form-field-'+index" :label="signupField.question" placeholder="" inlinerows="false" classes="bg-gray" ref="SignupFormField" v-model="signupField.value"></my-input>
                        </div>
                        <div class="mb-4" v-if="signupField.type == 2">
                          <label for="multivaluesignupformfield" class="form-label">{{ signupField.question }}</label>
                          <my-checkbox v-for="(option, index) in signupField.options" :key="index" id="option" name="option" inlinerows="false" :defaultText="option" secondaryText="" checkedValue="1" uncheckedValue="0" label="" v-model="signupField.value[option]"> </my-checkbox>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12 input-error" v-if="participant.course_assigned == true">{{ $t(LangConstants.participant_email_exist_error) }}</div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-12">
                      <hr />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-4">
                      <my-button fa="bars" :label="$t(LangConstants.contintue_with_payment_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>

          <div class="col-md-12" v-show="currentStep == 4">
            <div id="company-payment-select-payment-method" class="d-flex justify-content-center form-base mt-5 row">
              <b-form class="col-md-12" ref="frmOrderCompanypaymentMethod" @submit.stop.prevent="proceedBtnHandler">
                <h3 class="mb-3">
                  {{ $t(LangConstants.select_payment_method_heading) }}
                </h3>

                <section v-if="stateStep3.isActivated">
                  <div class="row price-section">
                    <div class="col total-desc">
                      <span class="total-text"> {{ product.name }} </span>
                    </div>
                    <div class="col-md-auto total-price">
                      <span class=""> {{ totalAmount }} </span>
                    </div>
                  </div>
                  <div class="row price-section">
                    <div class="col total-desc">
                      <span class="total-text">
                        Discount
                        <small>({{ discountPercentage }}%)</small>
                      </span>
                    </div>
                    <div class="col-md-auto total-price">
                      <span class=""> {{ discountPrice }} </span>
                    </div>
                  </div>
                  <hr />
                  <div class="row price-section font-weight-bold mb-3">
                    <div class="col total-desc">
                      <span class="total-text"> Total </span>
                    </div>
                    <div class="col-md-auto total-price">
                      <span class=""> {{ totalAmountWithDiscount }} </span>
                    </div>
                  </div>
                  <hr />
                </section>

                <div class="row">
                  <div class="col-12 form1">
                    <div class="row d-flex justify-content-center">
                      <div class="col-md-6">
                        <div class="mb-4">
                          <card-link fa="credit-card-alt" @onClick="payByCard" :title="$t(LangConstants.card_payment_title)" :text="$t(LangConstants.card_payment_helper_text)" bgvariant="red" textvariant="dark"></card-link>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <!-- TODO : Comment this div-->
                        <div class="mb-4">
                          <card-link fa="file" @onClick="handleInvoicePayment" :title="$t(LangConstants.invoice_payment_title)" :text="$t(LangConstants.invoice_payment_helper_text)"  bgvariant="blue" textvariant="dark"></card-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="invoice-address-model" hide-footer class="invoice-address-model" :title="$t(LangConstants.invoicing_address_data_title)" size="lg" v-model="invoiceAddressModalShow">
        <div class="row px-4 modal-body">
          <div class="col-md-12 mb-2">
            <h5>{{ $t(LangConstants.invoicing_address_data_description) }}</h5>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-4">
                  <my-input id="invoicingAddress" name="invoicingAddress" :label="$t(LangConstants.invoicing_address_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="invoicingAddress" v-model="stateStep4.invoicingAddress" :error="$v.stateStep4.$dirty && $v.stateStep4.invoicingAddress.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-4">
                  <my-input id="city" name="city" :label="$t(LangConstants.city_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="city" v-model="stateStep4.city" :error="$v.stateStep4.$dirty && $v.stateStep4.city.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-4">
                  <my-input id="zipCode" name="zipCode" :label="$t(LangConstants.zip_code_input_label)" placeholder="" inlinerows="false" classes="bg-gray" ref="zipCode" v-model="stateStep4.zipCode" :error="$v.stateStep4.$dirty && $v.stateStep4.zipCode.$invalid ? $t(LangConstants.invalid_input_error_message) : ''"></my-input>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 mt-2">
            <div class="row">
              <div class="col-md-6 mb-2">
                <my-button :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="46px" minwidth="100%" @onClick="validateInvoicingAddressData"></my-button>
              </div>
              <div class="col-md-6 mb-2">
                <my-button :label="$t(LangConstants.cancel_button_label)" variant="box-general-grey" classes="mr-1" height="46px" minwidth="100%" @onClick="$bvModal.hide('invoice-address-model')"></my-button>
              </div>
            </div>
          </div>
        </div>

        <template #modal-footer> </template>
      </b-modal>
    </div>

    <stripe-checkout ref="checkoutRef" mode="subscription" :pk="publishableKey" :line-items="lineItems" :success-url="successURL" :cancel-url="cancelURL" :session-id="sessionId" @loading="(v) => (loading = v)" />
  </div>
</template>

<style lang="scss" scoped>
.webshop-payment-page {
  margin-top: 20px;
}
.payment-page-in-mobile {
  margin-top: 3rem;
  @media screen and (max-width: 575px) {
    margin-top: 80px;
  }
}
</style>

<script>
/**
 * Webshop Payment Page
 */
//import useValidate from "@vuelidate/core";
import { required, email, requiredIf } from "vuelidate/lib/validators";
//import { reactive } from "@vue/composition-api";
import Common from "../../../../functions/index";
import Constants from "../../../../constants/index";

import WebshopProductItem from "../../../../components/atoms/WebshopProductItem.vue";
import "../../../../assets/scss/companypayment.scss";
import "../../../../assets/scss/stepper.scss";

import MyButton from "../../../../components/atoms/Button.vue";
import MyInput from "../../../../components/atoms/Input.vue";
import MyCheckbox from "../../../../components/atoms/Checkbox.vue";

import CardLink from "../../../../components/atoms/CardLink.vue";

import { StripeCheckout } from "@vue-stripe/vue-stripe";

import { store } from "../../../../store/store";

const dayjs = require("dayjs");

const passwordMustBeValid = (value) => {
  const re = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[-=_)(*^%$@!~`])[A-Za-z\d-=_)(*^%$@!~`]{6,}$/);
  return re.test(value);
};

const phoneNumberMustBeValid = (value) => {
  const re = new RegExp(/^[+]?[0-9]+$/);
  return re.test(value);
};

export default {
  name: "webshop-payment",
  async beforeCreate() {},

  // // const paymentAPI = this.generalSetting("woocommerce_integration_payment_api");
  async created() {
    // Getting route parameters
    this.courseId = this.$route.params.courseId;
    this.instanceId = this.$route.params.instanceId;
    this.quantity = this.$route.query.quantity;
    this.externalSessionId = this.$route.params.sessionId;
    const eventid = this.$route.query.event_id;

    // Creating stripe checkout payload template. check if this is actually needed
    this.stripeCheckoutSessionPayload = {
      params: {
        mode: "payment",
        success_url: "",
        cancel_url: "",
        payment_intent_data: {
          application_fee_amount: 0,
          receipt_email: "",
        },
        line_items: [],
        automatic_tax: {
          enabled: true,
        },
        tax_id_collection: {
          enabled: true,
        },
        metadata: {
          form_firstName: this.stateStep2.firstName,
          form_lastName: this.stateStep2.lastName,
          form_registerEmail: this.stateStep2.registerEmail,
          form_phone: this.stateStep2.phone,
          form_sendmarketingemails: this.stateStep2.sendmarketingemails,
          form_courseid: this.$route.params.courseId,
          form_instance_id: this.$route.params.instanceId,
          form_userType: this.userType,
          form_organizationName: this.stateStep2.organizationName,
          form_organizationNumber: this.stateStep2.organizationNumber,
          product: null,
        },
      },
      options: {
        stripe_account: "",
      },
    };

    // Creating stripe invoice payment  template
    this.stripeInvoiceItemPayload = {
      customer: "",
      amount: "",
      currency: "",
      StripeAccount: "",
    };

    this.stripeInvoicePayload = {
      customer: "",
      application_fee_amount: "",
    };

    let webshopcourse = await this.$store.dispatch("getWebshopCourse", {
      webshop_id: this.instanceId,
      course_id: this.courseId,
    });

    let price = 0;
    this.externalId = webshopcourse.data.external_id;
    this.course = webshopcourse.data.course;
    this.courseName = webshopcourse.data.course.name;
    this.selectedCourseType = webshopcourse.data.course.type;
    this.webshopId = webshopcourse.data.id;

    // console.log(this.course);
    // console.log(this.course.type);
    // console.log(this.courseName);

    // Set instructor led training related data
    let questions = null;
    if (this.selectedCourseType == "instructor_led_training") {
      this.event = webshopcourse.data.course.course_event.find((e) => e.id == eventid);

      if (this.event != null && this.event["registration_form"] != null) {
        // let questionRaw = this.event["registration_form"];
        // questionRaw = JSON.parse(questionRaw);

        // if (questionRaw["enableregistration"] == 1) {
        //   question = questionRaw["question"];
        // }

        questions = JSON.parse(this.event["registration_form"]);
        if (!Array.isArray(questions)) {
          questions = [{questionid : 0, question : questions.question, type : 1, value: null}];
        } else {
          questions.forEach(qst => {
            if (qst.type == 1) {
              qst.value = null;
            } else {
              let values = [];
              qst.options.forEach(opt => {
                values[opt] = "0";
              });
              qst.value = values;
            }
          });
        }
      }
    }

    // Create participant data if the quantity is greater than 0
    for (var i = 0; i < this.quantity; i++) {
      this.stateStep3.participants.push({
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        // signupField: {
        //   name: question,
        //   value: null,
        // },
        signupFields : questions,
        duplicatesVerified: true,
      });
    }

    await this.$store.dispatch("getAllSettings");

    // https://test.dgm.se/wp-json/dgm-lms/products?session_key=SESSION_KEY
    // https://test.dgm.se/wp-json/dgm-lms/product?sku=PRODUCT_ID&session_key=SESSION_KEY
    // https://test.dgm.se/wp-json/dgm-lms/cart

    if (this.woocommerceIntegration == true && webshopcourse.data.external_id) {
      const singleProductAPI = this.generalSetting("woocommerce_integration_single_product_api")
        .replace("SESSION_KEY", this.externalSessionId)
        .replace("PRODUCT_ID", webshopcourse.data.external_id);

      const external_product = await this.$store.dispatch("get", { url: singleProductAPI, config: "" });

      if (external_product) {
        this.woocommerceproduct = true;
      } else {
        alert("This product is not available in the woocommerce webshop");
      }
      this.disabledIndexes.push(2);

      price = this.getPriceByQuantity(this.quantity ? this.quantity : 1, external_product.prices);

      this.unitPrice_ = Common.formatMoney(price, Common.toUpperCase("SEK")); // from API Common.formatMoney(result.data.price, Common.toUpperCase(result.data.currency));

      this.product_ = {
        name: external_product.title,
        images: [webshopcourse.data.course.image == null ? Common.getImagefromContext("placeholder") : webshopcourse.data.course.image, ""],
        paymentRecurringPeriod: "month",
        description: webshopcourse.data.course.summary,
        price: price,
        quantity: this.quantity,
        currency: "SEK",
      };

      this.productPricing_ = {
        recurring: { interval: "one-time" },
        currency: webshopcourse.data.currency,
        quantity: this.quantity,
        unit_amount: price,
      };
    } else {
      this.unitPrice_ = Common.formatMoney(webshopcourse.data.price, Common.toUpperCase(webshopcourse.data.currency));

      // if (this.$route.query.quantity) {
      //   price = webshopcourse.data.price * this.$route.query.quantity;
      // } else {
      price = webshopcourse.data.price;
      // }

      this.product_ = {
        name: webshopcourse.data.course.name,
        images: [webshopcourse.data.course.image == null ? Common.getImagefromContext("placeholder") : webshopcourse.data.course.image, ""],
        paymentRecurringPeriod: "month",
        description: webshopcourse.data.course.summary,
        price: price,
        quantity: this.quantity,
        currency: webshopcourse.data.currency,
      };

      this.productPricing_ = {
        recurring: { interval: "one-time" },
        currency: webshopcourse.data.currency,
        unit_amount: price,
        quantity: this.quantity,
      };

      this.stripeCheckoutSessionPayload.params.metadata.product = this.product.name;
      this.stripeCheckoutSessionPayload.params.line_items.push({
        price_data: {
          tax_behavior: "inclusive",
          currency: this.product.currency,
          product_data: {
            name: this.product.name,
          },
          unit_amount: parseFloat(this.product.price) * 100,
        },
        //quantity: 1,
        quantity: this.quantity,
      });

      this.stripeCheckoutSessionPayload.options.stripe_account = webshopcourse.data.customer.stripe_connect_active_account.account_id;
      this.stripeCheckoutSessionPayload.params.success_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/subscription/success/{CHECKOUT_SESSION_ID}/card/" + webshopcourse.data.customer.stripe_connect_active_account.account_id;
      this.stripeCheckoutSessionPayload.params.cancel_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/subscription/failed/{CHECKOUT_SESSION_ID}/card/" + webshopcourse.data.customer.stripe_connect_active_account.account_id;

      this.stripeInvoiceItemPayload.amount = parseFloat(this.product.price) * 100;
      this.stripeInvoiceItemPayload.currency = this.product.currency;
      this.stripeInvoiceItemPayload.StripeAccount = webshopcourse.data.customer.stripe_connect_active_account.account_id;
      this.stripeInvoicePayload.StripeAccount = webshopcourse.data.customer.stripe_connect_active_account.account_id;
      this.customerParams["stripe_account"] = webshopcourse.data.customer.stripe_connect_active_account.account_id;

      this.$store
        .dispatch("getInstanceSettingsFiltered", {
          names: ["webshop_tranfer_fee_rate"],
          instance_id: this.$route.params.instanceId,
        })
        .then((webshopsettings) => {
          this.applicationFeeRate = webshopsettings.data.webshop_tranfer_fee_rate;
          const applicationFeeAmount = Common.calculateApplicationFee(this.applicationFeeRate, this.product.price);

          this.stripeCheckoutSessionPayload.params.payment_intent_data.application_fee_amount = applicationFeeAmount;
          this.stripeInvoicePayload.application_fee_amount = applicationFeeAmount;
        });
    }

    this.$root.$emit("webshop-payment-wizard-isablde-step", this.disabledIndexes);
  },
  setup() {
    return {
      loading: false,

      successURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/subscription/success",
      cancelURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/subscription/failed",
    };
  },
  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    return {
      invoiceAddressModalShow: {
        default: false,
      },
      formData: null,
      disabledIndexes: [],
      priceSlug: null,
      productSlug: null,
      lineItems: [
        {
          price: null, // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      stateSignIn: {
        loginEmail: null,
        password: null,
      },
      stateStep2: {
        isActivated: true,
        firstName: null,
        lastName: null,
        registerEmail: null,
        registerPassword: null,
        phone: null,
        organizationNumber: null,
        organizationName: null,
        sendmarketingemails: false,
      },
      stateStep3: {
        isActivated: true,
        groupName: null,
        participants: [],
      },
      stateStep4: {
        invoicingAddress: "",
        city: "",
        zipCode: "",
      },
      currentStep: 1,
      currentTab: "signup",
      userData: {},
      product_: [],
      stripeCheckoutSessionPayload: {},
      stripeInvoiceItemPayload: {},
      customerParams: {},
      webshopId: null,
      stripeInvoicePayload: {},
      productPricing_: null,
      unitPrice_: "",
      quantity: 0,
      // cardPayment: null,
      tabIndex: 0,
      sessionId: "",
      userType: "new",
      selectedCourseType: null,
      discountPercentage: 0,
      discountedPrice: 0,
      courseId: null,
      instanceId: null,
      externalSessionId: null,
      signInUser: {},
      course: "",
      courseName: "",
      event: {},
      applicationFeeRate: 0,
      isTrustedUser: false,
      teamLeadName: null,
      woocommerceproduct: false,
      externalId: 0,
      preorderid: "",
    };
  },

  methods: {
    validateInvoicingAddressData() {
      var validated = false;
      this.$v.stateStep4.$touch();
      validated = !this.$v.stateStep4.$invalid;

      if (validated) {
        this.invoiceAddressModalShow = false;
        this.processInternalInvoice();
      }
    },

    getPriceByQuantity(qty, priceDesc, calculatetotal = false) {
      let priceByQty = 0;

      for (let i = 0; i < priceDesc.length; i++) {
        let from = priceDesc[i]["from"];
        let to = priceDesc[i]["to"];
        let price = priceDesc[i]["price"] / 100;

        if (from > 0 && to != null && qty >= from && qty <= to) {
          priceByQty = price;
          break;
        }

        if (from > 0 && to == null && qty >= from) {
          priceByQty = price;
          break;
        }
      }

      if (calculatetotal == true) {
        priceByQty = priceByQty * qty;
      }

      return priceByQty;
    },

    generalSetting(key) {
      const settings = this.$store.getters.generalSettings;

      if (settings != null) {
        return settings.instanceSettings[key];
      }

      return false;
    },

    async proceedBtnHandler() {
      var validated = false;
      var userFormData = {};
      switch (this.currentStep) {
        case 1:
          this.incrementStep();
          break;
        case 2:
          if (this.tabIndex == 0) {
            this.$v.stateStep2.$touch();
            validated = !this.$v.stateStep2.$invalid;
            userFormData.username = this.stateStep2.registerEmail;
            userFormData.password = this.stateStep2.registerPassword;
            userFormData.action = "register";
            userFormData.organisationid = this.stateStep2.organizationNumber;
          } else {
            this.$v.stateSignIn.$touch();
            validated = !this.$v.stateSignIn.$invalid;
            userFormData.username = this.stateSignIn.loginEmail;
            userFormData.password = this.stateSignIn.password;
            userFormData.action = "login";
            userFormData.organisationid = 0;
          }

          if (validated == true) {
            this.$store
              .dispatch("loginWebShopUser", userFormData)
              .then((result) => {
                console.log("Login data");
                console.log(result);
                // Common.deleteFromLocalStorage(this.$route.params.id)
                if (this.tabIndex == 0) {
                  // Create Account

                  if (result.company_exist == 1) {
                    this.$fire({
                      title: this.$t(this.LangConstants.error_text),
                      text: this.$t(this.LangConstants.company_already_has_account),
                      type: "error",
                    });

                    return;
                  }

                  if (result.response != 0) {
                    this.$fire({
                      title: this.$t(this.LangConstants.error_text),
                      text: this.$t(this.LangConstants.email_already_has_account),
                      type: "error",
                    });
                  } else {
                    this.userType = "new";
                    this.moveToNextFromSecondStep();
                  }
                } else {
                  // Log in
                  if (result.response == 1) {
                    this.$fire({
                      title: this.$t(this.LangConstants.error_text),
                      text: this.$t(this.LangConstants.invalid_credentials),
                      type: "error",
                    });
                  } else if (result.response == 0) {
                    this.$fire({
                      title: this.$t(this.LangConstants.error_text),
                      text: this.$t(this.LangConstants.account_doesnot_exist),
                      type: "error",
                    });
                  } else {
                    this.signInUser = {
                      userid: result.data.userid,
                      instance_id: this.instanceId,
                    };
                    if (result.data.teamlead) {
                      this.teamLeadName = result.data.teamlead;
                    }
                    if (result.data.istrusted) {
                      this.isTrustedUser = result.data.istrusted;
                    }
                    if (result.data.discountcode) {
                      this.discountPercentage = result.data.discountcode;
                    }

                    this.userType = "old";
                    this.moveToNextFromSecondStep();
                  }
                }
              })
              .catch((error) => {
                this.$fire({
                  title: this.$t(this.LangConstants.error_text),
                  text: this.$t(this.LangConstants.common_error_title),
                  type: "error",
                  html: "<div>" + this.$t(error) + "</div>",
                });
              });
          }

          break;

        case 3: {
          this.$v.stateStep3.$touch();
          let emailsVerified = true;
          if (this.stateStep3.participants.length > 1) {
            let uniqueEmails = [];
            this.stateStep3.participants.forEach((p) => {
              if (uniqueEmails.includes(p.email.toLowerCase())) {
                p.duplicatesVerified = false;
                emailsVerified = false;
              } else {
                uniqueEmails.push(p.email.toLowerCase());
                p.duplicatesVerified = true;
              }
            });
          }
          if (!this.$v.stateStep3.$invalid && emailsVerified) {

            //add values to signup forms
            this.stateStep3.participants.forEach(participant => {
              if (participant.signupFields && participant.signupFields.length > 0) {
                participant.signupFields.forEach(qst => {
                let values = [];
                if (qst.type == 2) {
                  qst.options.forEach(opt => {
                    if (qst.value[opt] == "1") {
                      values.push(opt);
                    }
                  });
                } else {
                  values = [qst.value];
                }
                qst.value = JSON.stringify(values);
              });
              }
            });
            
            let form = {
              courseid: this.courseId,
              instance_id: this.instanceId,
              users: this.stateStep3.participants,
            };

            this.$store.dispatch("courseAssignmentEnrolled", form).then((result) => {
              this.stateStep3.participants = result.data;
              let hasErrors = this.stateStep3.participants.some((e) => e.course_assigned == true);
              if (!hasErrors) {
                this.moveToNextFromThirdStep();
                // this.incrementStep();
              }
            });
          }

          break;
        }
      }
    },

    async processLogin() {},

    async ProcessRegister() {},

    async payByCard() {
      if (this.discountPercentage != 0) {
        let total = this.product.price - this.discountedPrice;
        this.stripeCheckoutSessionPayload.params.line_items[0].price_data.unit_amount = parseFloat(total) * 100;
        this.stripeInvoiceItemPayload.amount = parseFloat(total) * 100;

        const applicationFeeAmountWithDiscount = Common.calculateApplicationFee(this.applicationFeeRate, total);

        this.stripeCheckoutSessionPayload.params.payment_intent_data.application_fee_amount = applicationFeeAmountWithDiscount;
        this.stripeInvoicePayload.application_fee_amount = applicationFeeAmountWithDiscount;
      }
      this.stripeCheckoutSessionPayload.params.metadata.form_firstName = this.stateStep2.firstName;
      this.stripeCheckoutSessionPayload.params.metadata.form_lastName = this.stateStep2.lastName;
      this.stripeCheckoutSessionPayload.params.metadata.form_registerEmail = this.stateStep2.registerEmail;
      this.stripeCheckoutSessionPayload.params.metadata.form_phone = this.stateStep2.phone;
      this.stripeCheckoutSessionPayload.params.metadata.form_organizationName = this.stateStep2.organizationName;
      this.stripeCheckoutSessionPayload.params.metadata.form_organizationNumber = this.stateStep2.organizationNumber;
      this.stripeCheckoutSessionPayload.params.metadata.form_sendmarketingemails = this.stateStep2.sendmarketingemails;

      this.stripeCheckoutSessionPayload.params.payment_intent_data.receipt_email = this.tabIndex == 0 ? this.stateStep2.registerEmail : this.stateSignIn.loginEmail;
      this.stripeCheckoutSessionPayload.params.customer_email = this.tabIndex == 0 ? this.stateStep2.registerEmail : this.stateSignIn.loginEmail;

      this.$store.dispatch("createStripeCheckout", this.stripeCheckoutSessionPayload).then((session) => {
        if (session.success == true) {
          this.sessionId = session.data.id;
          this.cacheFormData(session.data.id);
          window.location.href = session.data.url;
        } else {
          this.$fire({
            title: this.$t(Constants.common_error_title),
            text: this.$t(Constants.please_try_again_text),
            type: "error",
            html: "",
          });
        }
      });
    },

    async handleInvoicePayment() {
      const prodType = this.selectedCourseType != null ? this.selectedCourseType : "";

      switch (prodType) {
        case "instructor_led_training":
          if (this.userType == "new") {
            this.invoiceAddressModalShow = true;
          } else {
            this.processInternalInvoice();
          }

          break;
        default:
          this.processStripeInvoice();
          break;
      }
    },

    async processInternalInvoice() {
      // Registerant/login data
      // Course and Event Data
      // Student Data
      // Payment Records Data ( Create new record );

      const id = Common.randomId();
      this.cacheFormData(id);

      this.$router.push({
        path: `/company-account/webshop/purchase/subscription/success/${id}/invoice_internal/null`,
        // params: {
        //   id: id,
        //   type: "invoice_internal",
        //   connectedAccount: null,
        // },
      });
    },

    async processStripeInvoice() {
      this.customerParams.email = this.userType == "new" ? this.stateStep2.registerEmail : this.stateSignIn.loginEmail;

      await this.$store
        .dispatch("createStripeConnectedAccountCustomer", this.customerParams)
        .then((result) => {
          result = JSON.parse(JSON.stringify(result));

          let subscriptionParams = {
            customer: result["id"],
            "items[0][price]": "0",
            // "payment_settings[payment_method_types][]": "card",
            collection_method: "send_invoice",
            days_until_due: 30,

            "metadata[product]": this.product.name,

            "metadata[form_firstName]": this.stateStep2.firstName,
            "metadata[form_lastName]": this.stateStep2.lastName,
            "metadata[form_registerEmail]": this.stateStep2.registerEmail,
            "metadata[form_phone]": this.stateStep2.phone,
            "metadata[form_sendmarketingemails]": this.stateStep2.sendmarketingemails,
            "metadata[form_userType]": this.userType,
            "metadata[form_webshopId": this.webshopId,
          };

          if (this.userType == "new") {
            subscriptionParams["metadata[form_firstName]"] = this.stateStep2.firstName;
            subscriptionParams["metadata[form_lastName]"] = this.stateStep2.lastName;
            subscriptionParams["metadata[form_registerEmail]"] = this.stateStep2.registerEmail;
            subscriptionParams["metadata[form_phone]"] = this.stateStep2.phone;
            subscriptionParams["metadata[form_sendmarketingemails]"] = this.stateStep2.sendmarketingemails;
            subscriptionParams["metadata[form_userType]"] = this.stateStep2.userType;
          } else {
            subscriptionParams["metadata[form_registerEmail]"] = this.stateSignIn.loginEmail;
          }

          this.stripeInvoiceItemPayload.customer = result["id"];
          this.stripeInvoicePayload.customer = result["id"];

          this.$store
            .dispatch("createStripeInvoiceItem", this.stripeInvoiceItemPayload)
            .then((result) => {
              console.log(result);

              this.$store
                .dispatch("createStripeInvoice", this.stripeInvoicePayload)
                .then((result) => {
                  this.$router.push({
                    name: "CompanyWebshopPaymentSuccess",
                    params: {
                      id: result.data.id,
                      type: "invoice",
                      connectedAccount: this.stripeInvoicePayload.StripeAccount,
                    },
                  });
                })
                .catch((error) => {
                  this.$fire({
                    title: this.$t(this.LangConstants.invoice_creation_status_heading),
                    text: this.$t(this.LangConstants.invoice_creation_failed_text),
                    type: "error",
                    html: "<div>" + this.$t(error) + "</div>",
                    timer: 3000,
                  }).then(() => {
                    this.$router.push({ name: "CompanyWebshopPaymentFail" });
                  });
                });
            })
            .catch((error) => {
              this.$fire({
                title: this.$t(this.LangConstants.invoice_creation_status_heading),
                text: this.$t(this.LangConstants.invoice_creation_failed_text),
                type: "error",
                html: "<div>" + this.$t(error) + "</div>",
                timer: 3000,
              }).then(() => {
                this.$router.push({ name: "CompanyWebshopPaymentFail" });
              });
            });
        })
        .catch((error) => {
          this.$fire({
            title: this.$t(this.LangConstants.invoice_creation_status_heading),
            text: this.$t(this.LangConstants.invoice_creation_failed_text),
            type: "error",
            html: "<div>" + this.$t(error) + "</div>",
            timer: 3000,
          }).then(() => {
            this.$router.push({ name: "CompanyWebshopPaymentFail" });
          });
        });
    },

    async payByWoocommerceMethod() {
      let apiBaseURL = "";
      if (Common.isValidHttpUrl(process.env.VUE_APP_API_BASE_URL) == true) {
        apiBaseURL = process.env.VUE_APP_API_BASE_URL;
      } else {
        let inst = this.$store.getters.instanceUrl;
        let apiBase = process.env.VUE_APP_API_BASE_URL;

        inst = inst.endsWith("/") ? inst : inst + "/";
        apiBase = apiBase.startsWith("/") ? apiBase.substring(1) : apiBase;

        apiBaseURL = inst + apiBase;
      }

      let vueBaseUrl = store.getters.spInstanceVueURL;
      vueBaseUrl = !vueBaseUrl.endsWith("/") ? vueBaseUrl + "/" : vueBaseUrl;
      apiBaseURL = !apiBaseURL.endsWith("/") ? apiBaseURL + "/" : apiBaseURL;
      this.preorderid = "WOO-" + Date.now() + this.$route.params.instanceId;

      const id = Common.randomId();
      await this.cacheFormData(id);

      let quantity = !this.formData.product.quantity ? 1 : this.formData.product.quantity;
      let amount = (this.formData.product.discount_amount ? this.formData.product.amount - this.formData.product.discount_amount : this.formData.product.amount) * quantity;

      let payload = {
        webshop_payment: {
          order_reference_id: this.preorderid,
          instance_id: this.formData.user.instance_id,
          date_paid: Date.now(),
          status: this.formData.customer.invoiceallowed ? "success" : "pending",
          method: "woocommerce_integration",
          return_log: JSON.stringify({}),

          event_id: this.formData.product.event_id,
          total: amount,
          sub_total: this.formData.product.amount * quantity,
          discount: this.formData.product.discount_amount,
          currency: this.formData.product.currency,
          quantity: this.formData.product.quantity,
          group_name: this.formData.group_name,
        },
        stripe_connect_account_id: null,
        webshop_id: this.formData.product.webshopId,
        charge_id: null,
        payment_intent_response: JSON.stringify({}),
        participants: this.formData.participants,
        moodle_payload: {
          user: {
            lms_url: window.location.origin,
            instance_id: this.formData.user.instance_id,
            first_name: this.formData.user.first_name,
            last_name: this.formData.user.last_name,
            email: this.formData.user.email,
            password: this.formData.user.password,
            phone_1: this.formData.user.phone,
            courseid: this.formData.user.courseid,
            eventid: this.formData.product.event_id,
            groupName: this.formData.user.group_name,
            participants: this.formData.participants,
          },
          method: "woocommerce_integration",
        },
      };

      await this.$store.dispatch("createTemporaryWebshopPayment", { temporary_webshop_order: { key: id, value: JSON.stringify(payload) } });

      const wooPayload = {
        session_key: this.externalSessionId,
        instance_id: this.$route.params.instanceId,
        payment_id: this.preorderid,
        order: [
          {
            quantity: this.quantity,
            product_id: this.externalId,
          },
        ],

        participants: this.stateStep3.isActivated ? this.stateStep3.participants : [],
        success_url: vueBaseUrl + `company-account/webshop/purchase/subscription/success/${id}/woocommerce_integration/null`,
        fail_url: vueBaseUrl + `company-account/webshop/purchase/subscription/failed/${id}/woocommerce_integration/null`,
        purchase_complete_api: apiBaseURL + `temporarywebshoporder/confirm/${id}`,
        callback_api: apiBaseURL + `webshoppayment/woocommerceintegrationupdate/${this.preorderid}`, // POST
      };

      const singleProductAPI = this.generalSetting("woocommerce_integration_payment_api").replace("SESSION_KEY", this.externalSessionId);
      const wooResponse = await this.$store.dispatch("post", { url: singleProductAPI, data: wooPayload, config: "" });

      console.log("payment API Endpoint");
      console.log(singleProductAPI);
      console.log("payment API Woocommerce Response");
      console.log(wooResponse);

      if (wooResponse.data.success == true) {
        window.location.href = wooResponse.data.redirect_to;
      } else {
        alert("We couldnt initiate the payment with the dependant host");
      }

      // window.location.href = vueBaseUrl + `company-account/webshop/purchase/subscription/success/${id}/woocommerce_integration/null`
    },

    incrementStep(init = false) {
      if (init == true && this.stateStep3.participants.length > 1) {
        this.$refs.groupName.text = this.stateStep3.groupName = this.product.name + (this.event != undefined ? " - " + dayjs(this.event.start_date).format("DD-MM-YYYY") : "");
      }

      let i = 1;
      if (this.currentStep > 0) {
        let c = this.currentStep;

        while (this.disabledIndexes.indexOf(++c) > -1) {
          c = c + 1;
          i = i + 1;
        }
      }

      this.currentStep += i;
      this.$root.$emit("webshop-payment-wizard-step", this.currentStep);
    },

    async moveToNextFromThirdStep() {
      if (this.woocommerceproduct == true) {
        // this.course.type == "elearning" &&
        this.payByWoocommerceMethod();
      } else if (this.course.type == "elearning" && this.woocommerceproduct == false) {
        this.payByCard();
      } else if (this.course.type == "instructor_led_training") {
        this.incrementStep();
      }
    },

    async moveToNextFromSecondStep() {
      if (this.stateStep3.isActivated) {
        if (this.stateStep3.participants.length == 1) {
          if (this.userType == "old") {
            const result = await this.$store.dispatch("userGetFirst", this.signInUser); //.then((result) => {
            this.signInUser = result.data;

            if (result.data.company != null) {
              this.quantity;
              const max_licenses = parseInt(result.data.company.maximum_license);
              const used_license = parseInt(result.data.company.used_licenses);

              if (max_licenses < used_license + this.quantit) {
                this.$fire({
                  title: "",
                  text: "",
                  type: "info",
                  html: "<div>" + this.$t(this.LangConstants.webshop_company_licence_max_allowed_reached_warning) + "</div>",
                  timer: 4000,
                });
                return;
              }

              if (result.data.company.active != true) {
                this.$fire({
                  title: "",
                  text: "",
                  type: "info",
                  html: "<div>" + this.$t(this.LangConstants.inactive_company_warning) + "</div>",
                  timer: 4000,
                });
                return;
              }
            } else {
              if (this.selectedCourseType == "instructor_led_training") {
                this.$fire({
                  title: "",
                  text: "",
                  type: "info",
                  html: "<div>" + this.$t(this.LangConstants.buyer_doesnt_belong_to_a_company_error) + "</div>",
                  timer: 4000,
                });

                return;
              }
            }

            if (this.signInUser?.role_assignment?.find((role) => role.roleid == Constants.teamlead) == null) {
              this.$fire({
                title: "",
                text: "",
                type: "info",
                html: "<div>" + this.$t(this.LangConstants.sign_in_user_notification_for_new_users).replace("{Team Lead Name}", this.teamLeadName ? this.teamLeadName : this.$t(this.LangConstants.vendor_text)) + "</div>",
                timer: 4000,
              });
            }
            this.$refs.pFirstName[0].text = this.stateStep3.participants[0].firstName = this.signInUser.first_name;
            this.$refs.pLastName[0].text = this.stateStep3.participants[0].lastName = this.signInUser.last_name;
            this.$refs.pEmail[0].text = this.stateStep3.participants[0].email = this.signInUser.email;
            this.$refs.pPhone[0].text = this.stateStep3.participants[0].phone = this.signInUser.phone;
            // });
          } else if (this.userType == "new") {
            this.$refs.pFirstName[0].text = this.stateStep3.participants[0].firstName = this.stateStep2.firstName;
            this.$refs.pLastName[0].text = this.stateStep3.participants[0].lastName = this.stateStep2.lastName;
            this.$refs.pEmail[0].text = this.stateStep3.participants[0].email = this.stateStep2.registerEmail;
            this.$refs.pPhone[0].text = this.stateStep3.participants[0].phone = this.stateStep2.phone;
          }
        } else {
          this.$refs.groupName.text = this.stateStep3.groupName = this.courseName + (this.event != undefined ? " - " + dayjs(this.event.start_date).format("DD-MM-YYYY") : "");
        }
        this.incrementStep();
      } else {
        this.payByCard();
      }
    },

    calculateDiscount() {
      this.discountedPrice = ((this.discountPercentage / 100) * this.product.price).toFixed(2);
    },

    getDefaultAmountValue() {
      let currency = this.productPricing != null && this.productPricing.currency ? Common.toUpperCase(this.productPricing.currency) : "";
      return "00.00 " + currency;
    },

    async cacheFormData(key, server = false) {
      let formData = {};

      if (this.userType == "new") {
        formData = {
          user: {
            first_name: this.stateStep2.firstName,
            last_name: this.stateStep2.lastName,
            email: this.stateStep2.registerEmail,
            password: this.stateStep2.registerPassword,
            phone: this.stateStep2.phone,
            receive_marketing_emails: this.stateStep2.sendmarketingemails,
            courseid: this.$route.params.courseId,
            instance_id: this.$route.params.instanceId,
            userType: this.userType,
            courseType: this.selectedCourseType,
          },
          participants: this.stateStep3.isActivated ? this.stateStep3.participants : [],
          customer: {
            organization_number: this.stateStep2.organizationNumber,
            organization_name: this.stateStep2.organizationName,
            invoiceallowed: this.isTrustedUser,

            address: this.stateStep4.invoicingAddress,
            city: this.stateStep4.city,
            postalcode: this.stateStep4.zipCode,
          },
          group_name: this.stateStep3.isActivated ? this.stateStep3.groupName : null,
          product: {
            webshopId: this.webshopId,
            amount: this.product.price,
            event_id: this.event ? this.event.courseeventid : null,
            quantity: this.quantity,
            unit_price: this.unitPrice,
            currency: this.product.currency,
            productName: this.product.name,
          },
          payment: {
            preorderid: this.preorderid,
          },
        };
      } else {
        formData = {
          user: {
            email: this.stateSignIn.loginEmail,
            password: this.stateSignIn.password,
            courseid: this.$route.params.courseId,
            instance_id: this.$route.params.instanceId,
            userType: this.userType,
            courseType: this.selectedCourseType,
            is_teamlead: this.signInUser?.role_assignment?.find((role) => role.roleid == Constants.teamlead) ? true : false,
          },
          participants: this.stateStep3.isActivated ? this.stateStep3.participants : [],
          customer: {
            organization_number: "",
            organization_name: "",
            invoiceallowed: this.isTrustedUser,

            address: "",
            city: "",
            postalcode: "",
          },
          group_name: this.stateStep3.isActivated ? this.stateStep3.groupName : null,
          product: {
            webshopId: this.webshopId,
            amount: this.product.price,
            discount_amount: this.discountedPrice,
            event_id: this.event ? this.event.courseeventid : null,
            quantity: this.quantity,
            unitPrice: this.unitPrice,
            currency: this.product.currency,
            productName: this.product.name,
          },
          payment: {
            preorderid: this.preorderid,
          },
        };
      }
      this.formData = formData;
      Common.setinLocalStorage(key, formData);
      if (server) {
        await this.$store.dispatch("createTemporaryWebshopPayment", { temporary_webshop_order: { key: key, value: JSON.stringify(formData) } });
      }
    },
  },
  computed: {
    product() {
      return this.product_;
    },
    unitPrice() {
      return this.unitPrice_;
    },
    productPricing() {
      return this.productPricing_;
    },
    woocommerceIntegration() {
      const settings = this.$store.getters.generalSettings;
      if (settings != null && settings.instanceSettings.woocommerce_integration == 1) {
        return true;
      }

      return false;
    },
    customers() {
      return this.$store.getters.allCustomers;
    },

    totalAmount() {
      if (this.productPricing != null) {
        const prodPricing = this.productPricing.unit_amount * this.quantity;
        return Common.formatMoney(prodPricing, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
    paymentRecurringPeriod() {
      if (this.productPricing != null) {
        return this.productPricing.recurring ? Common.getIntervalByNoun(this.productPricing.recurring.interval) : "";
      }
      return "";
    },

    LangConstants() {
      return Constants;
    },

    marketingConsentHelperText() {
      return "(" + this.$t(Constants.marketing_consent_helper_text) + ")";
    },

    discountPrice() {
      if (this.discountPercentage != 0) {
        this.calculateDiscount();
        return Common.formatMoney(this.discountedPrice, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },

    totalAmountWithDiscount() {
      if (this.productPricing != null) {
        let total = this.productPricing.unit_amount - this.discountedPrice;
        total = total * this.productPricing.quantity;
        return Common.formatMoney(total, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
    currentEvent() {
      return this.event;
    },
  },

  validations: {
    stateSignIn: {
      loginEmail: { required, email },
      password: { required },
    },
    stateStep2: {
      firstName: { required },
      lastName: { required },
      registerEmail: { required, email },
      registerPassword: {
        required,
        passwordMustBeValid,
      },
      phone: { required, phoneNumberMustBeValid },
      organizationNumber: { required },
      organizationName: { required },
    },
    stateStep3: {
      groupName: {
        required: requiredIf(function() {
          return this.stateStep3.isActivated && this.quantity > 1;
        }),
      },
      participants: {
        $each: {
          firstName: { required },
          lastName: { required },
          email: { required, email },
          phone: { required, phoneNumberMustBeValid },
        },
      },
    },
    stateStep4: {
      invoicingAddress: { required },
      city: { required },
      zipCode: { required },
    },
  },

  components: {
    WebshopProductItem,
    MyButton,
    MyInput,
    MyCheckbox,
    CardLink,
    StripeCheckout,
  },
};
</script>
